import { useOutletContext } from 'react-router-dom'

import DashboardList from 'modules/reports/components/DashboardList'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'

const DashboardListPage = () => {
  const { loading } = useOutletContext<RouteContextParams>()

  return <DashboardList loading={loading} />
}

export default DashboardListPage
